<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pb-2 mt-1" >
                <v-col sm="8" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('boxes.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0">
                    <v-row class="mx-0 my-0 px-0 py-0" justify="end">
                        <v-btn class="right mr-2 tools-view-height" outlined color="secondary" :to="'/consumables'" v-permission="'consumable.index'">
                            {{ $t('boxes.manage_stock') }}
                        </v-btn>
                        <v-btn class="right white_highlight--text tools-view-height" color="secondary" :to="'/boxes/create'" v-permission="'box.create'">
                            {{ $t('boxes.new') }}
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :props="{headers:headers, items: props.items, search:props.search}" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
            <v-dialog v-model="modalDelete" persistent max-width="90%">
                <v-card >
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                                <h3 class="text-uppercase">
                                    {{ $t('boxes.modal.delete') }}
                                </h3>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="py-3 my-3 text-center">
                            <v-col cols="12">
                                <h5>{{ $t('boxes.modal.message') }}</h5>
                            </v-col>
                        </v-row>
                        
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalDelete = false">{{ $t('boxes.no') }}</v-btn>
                            <v-btn color="error" @click="deleteBox">
                                {{ $t('boxes.yes') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker"></div>
                </v-card>
            </v-dialog>
            </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
import { boxConsumableIndexUseCase } from "../../boxes/application/use_cases/box_consumable_index_use_case";
import { HttpBoxRepository } from "../../boxes/infrastructure/box_repository";

export default {
    computed: {
        headers(){
            return [
                { text: this.$t('boxes.name'), align: "center", value: 'consumable.name', class: 'text-uppercase' },
                { text: this.$t('boxes.length'), align: "center", value: 'consumable.length', class: 'text-uppercase' },
                { text: this.$t('boxes.width'), align: "center", value: 'consumable.width', class: 'text-uppercase' },
                { text: this.$t('boxes.height'), align: "center", value: 'consumable.height', class: 'text-uppercase' },
                { text: this.$t('boxes.weight'), align: "center", value: 'consumable.units', class: 'text-uppercase' },
                { text: this.$t('boxes.stock'), align: "center", value: 'stock', class: 'text-uppercase' },
                { text: this.$t('boxes.alert'), align: "center", value: 'stockMin', class: 'text-uppercase' },
                { text: this.$t('boxes.actions'), align: "center", value: 'actions', class: 'text-uppercase' },
            ];
        } 
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            modalDelete: false,
            idBox: '',
            props: {
                search: '',
                items: [],
            }
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.boxes";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async index(){
            this.props.items = [];

            const result = await boxConsumableIndexUseCase(HttpBoxRepository);
            this.props.items = result.data.data;
        },
        askDelete(box){
            this.modalDelete = true;
            this.idBox = box;
        },
        deleteBox(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.delete(this.$store.state.chronosApi + 'boxes/' + this.idBox, {headers: {Authorization: lsToken}})
            .then((response) => {
                if(response.status === 200){
                    this.modalDelete = false;
                    this.index();
                    this.$store.state.loaderProps.visible = false;
                }
            })
            .catch((response) => {
                this.$store.state.loaderProps.visible = false;
                if(response.status !== 200){
                    this.snackbar = {
                        visible: true,
                        color: 'red',
                        text: this.$t('pendings.responses.error')
                    }
                }
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            });
        }
    }
}
</script>

<style>

</style>